import { useEffect } from 'react';
import { isTokenExpired, getStoredTokens } from './tokenStorage';
import { refreshAccessToken } from './tokenManager';

/**
 * Background refresh timer. Fires every 60s and refreshes when expiry is
 * within 90s (so the SPA rarely hits a 401 while the user is active).
 */
export function useTokenRefresh(audience: 'admin' | 'entrant' = 'admin'): void {
  useEffect(() => {
    const tick = async () => {
      if (!getStoredTokens()) return;
      if (isTokenExpired(90)) {
        try {
          await refreshAccessToken(audience);
        } catch {
          /* handled inside refreshAccessToken */
        }
      }
    };
    const handle = window.setInterval(tick, 60_000);
    // Also refresh on tab becoming visible after a long idle.
    const visHandler = () => {
      if (document.visibilityState === 'visible') void tick();
    };
    document.addEventListener('visibilitychange', visHandler);
    return () => {
      window.clearInterval(handle);
      document.removeEventListener('visibilitychange', visHandler);
    };
  }, [audience]);
}
